import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { runRetentionCleanupIfNeeded, touchLastActivity } from "./utils/dataRetention";

const root = document.getElementById('root');
if (!root) {
    throw new Error('Could not find root element to mount to');
}

try {
  touchLastActivity(Date.now());
  void runRetentionCleanupIfNeeded(Date.now());
} catch {
  void 0;
}

const app = (
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
);

// Use hydration for SSR in production
if (import.meta.env.PROD) {
  hydrateRoot(root, app);
} else {
  createRoot(root).render(app);
}
